import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Col, Pagination, Row } from 'react-bootstrap';
import qs from 'qs';
import { pickBy } from 'lodash';

import PropTypes from 'prop-types';
import { useReports } from '../..';

import { formatedStringCounters, makePaginationArray } from '../../../../../components/Pagination/helpers';

const FakePagination = ({ fakePageSize, stack }) => {
  const history = useHistory();
  const location = useLocation();

  const queryString = qs.parse(location.search.slice(1));

  const { pagination } = useReports();
  const currentPage = Math.max(1, parseInt(stack || 1, 10));

  const totalPages = Math.ceil(pagination.total_count / fakePageSize);

  const getPage = (newStack) => {
    if (newStack > 10) {
      return Math.ceil(newStack / 10);
    }
    return 1;
  }

  const onChangePagination = (newStack) => {
    const { page, stack, ...restQueryString } = queryString;
    const currentPage = getPage(newStack);
    const newPage = currentPage === 1 ? null : currentPage;
    const newQuery = newStack === 1 ? restQueryString : { ...restQueryString, page: newPage, stack: newStack };
    history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy(newQuery)),
    });
  }

  return (
    <Row>
      <Col sm={7}>
        {totalPages > 1 && (
          <Pagination>
            {currentPage !== 1 ? (
              <Pagination.First disabled={currentPage === 1} onClick={() => (currentPage === 1 ? null : onChangePagination(currentPage - 1))} />
            ) : null}
            {totalPages
              && makePaginationArray(totalPages, currentPage, 10)?.map((item) => (
                <Pagination.Item key={item} active={currentPage === Number(item)} onClick={() => onChangePagination(item)}>
                  {item}
                </Pagination.Item>
              ))}
            {currentPage !== totalPages ? (
              <Pagination.Last
                disabled={currentPage === totalPages}
                onClick={() => (currentPage === totalPages ? null : onChangePagination(currentPage + 1))}
              />
            ) : null}
          </Pagination>
        )}
      </Col>
      {pagination.total_count > 0 && (
        <Col sm={5} className="pagination-counters">
          {formatedStringCounters(currentPage, fakePageSize, pagination.total_count)}
          {'.'}
        </Col>
      )}
    </Row>
  )
};

FakePagination.propTypes = {
  fakePageSize: PropTypes.number,
  stack: PropTypes.number,
}

FakePagination.defaultProps = {
  fakePageSize: 100,
}

export default FakePagination;
